/* @flow */
import memoize from 'memoizee';

import { dispatcher } from 'lib/Dispatcher';
import ChatMessages from 'collections/ChatMessages';
import { ChatGapMessage, ChatMessage } from 'entities/ChatMessage';
import { ActionTypes, DATA_RELOAD_TIMEOUT_MS } from 'chat/constants/ChatConstants';
import ReactionSummary from 'entities/ReactionSummary';

const ChatMessageActions = {
  sendMessage(message: ChatMessage) {
    dispatcher.dispatch({
      type: ActionTypes.SEND_MESSAGE,
      chatId: message.getChatId(),
      message,
    });

    const onSuccess = () => {
      dispatcher.dispatch({
        type: ActionTypes.SENT_MESSAGE,
        message,
      });
    };

    const onError = () => {
      dispatcher.dispatch({
        type: ActionTypes.MESSAGE_FAILED,
        message,
      });
    };

    return message.send().then(onSuccess, onError);
  },

  removeMessage(message: ChatMessage) {
    dispatcher.dispatch({
      type: ActionTypes.REMOVE_MESSAGE,
      message,
    });
  },

  addReaction(message: ChatMessage, reactionName: string) {
    ReactionSummary.createReaction(reactionName, message.getChatId(), message.getUuid())
      .then(reactionSummary => {
        dispatcher.dispatch({
          type: ActionTypes.ADD_CHAT_MESSAGE_REACTION,
          message,
          reactionSummary,
        });
      })
      .catch(e => console.error('ReactionSummary.createReaction failed', e));
  },

  removeReaction(message: ChatMessage, reactionName: string) {
    ReactionSummary.deleteReaction(reactionName, message.getChatId(), message.getUuid())
      .then(reactionSummary => {
        dispatcher.dispatch({
          type: ActionTypes.REMOVE_CHAT_MESSAGE_REACTION,
          message,
          reactionSummary,
        });
      })
      .catch(e => console.error('ReactionSummary.deleteReaction failed', e));
  },

  loadMissingChatMessages(chatId: string, sinceSeq: ?number = null, maxSeq: ?number = null) {
    const data = {};
    if (sinceSeq) {
      data.since_seq = sinceSeq;
    }
    if (maxSeq) {
      data.max_seq = maxSeq;
    }

    return ChatMessages.yieldMessagesForChatId(chatId, { data }).then(messages => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_MISSING_CHAT_MESSAGES,
        chatId,
        messages,
      });
    });
  },

  loadChatMessages(chatId: string): void {
    ChatMessages.yieldMessagesForChatId(chatId).then(messages => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_CHAT_MESSAGES,
        chatId,
        messages,
      });
    }).catch(e => console.error('ChatMessages.yieldMessagesForGap failed', e));
  },

  updateChatsMessages(chatsMessages: {[key: string]: ChatMessages}) {
    dispatcher.dispatch({
      type: ActionTypes.UPDATE_CHATS_MESSAGES,
      chatsMessages,
    });
  },

  fillGap: memoize((gap: ChatGapMessage) => {
    ChatMessages.yieldMessagesForGap(gap).then(messages => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_GAP_MESSAGE,
        chatId: gap.getChatId(),
        gapId: gap.id,
        messages,
      });
    }).catch(e => console.error('ChatMessages.yieldMessagesForGap failed', e));
  }, {
    maxAge: DATA_RELOAD_TIMEOUT_MS,
  }),
};

export default ChatMessageActions;



// WEBPACK FOOTER //
// ./src/chat/actions/ChatMessageActions.js